class HistoryX {

  /**
   * 
   * @param {String} queryString 
   */
  static PushState(queryString){
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
    window.history.pushState({path: newurl}, "", newurl);
  }

  /**
   * 
   * @param {String} queryString 
   */
  static ReplaceState(queryString){
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
    window.history.replaceState({path: newurl}, "", newurl);
  }

  /**
   * 
   * @returns 
   */
  static GetQueryString(){
    return window?.location?.search ?? "";
  }

  static Reload(){
    window?.location?.reload?.();
  }

}

export default HistoryX;